import InvoiceBatches from './InvoiceBatches';

export default InvoiceBatches;
